<h1 class="title-principal">Cambiar Contraseña</h1>
<section class="body-app gradiente">
  <form
    (ngSubmit)="change()"
    [formGroup]="keyChange"
    class="report-box"
    fxLayout="column"
    fxLayoutAlign="start center"
  >
    <span class="title-report">Cambio de Contraseña</span>
    <mat-form-field appearance="fill">
      <mat-label>Clave nueva</mat-label>
      <input
        matInput
        formControlName="passwordNew"
        [type]="hideNew ? 'password' : 'text'"
      />
      <mat-error>
        <div *ngIf="keyChange.get('passwordNew').hasError('required')">
          {{ "Ingrese contraseña" }}
        </div>
        <div *ngIf="keyChange.get('passwordNew').hasError('pattern')">
          {{
            "La contraseña debe tener entre 8 y 16 caracteres, al menos un dígito, al menos una minúscula y al menos una mayúscula."
          }}
        </div>
      </mat-error>
      <button
        mat-icon-button
        matSuffix
        (click)="hideNew = !hideNew"
        [attr.aria-label]="'Hide password'"
        [attr.aria-pressed]="hideNew"
      >
        <mat-icon>{{ hideNew ? "visibility_off" : "visibility" }}</mat-icon>
      </button>
    </mat-form-field>

    <mat-form-field appearance="fill">
      <mat-label>Clave nueva (Confirmación))</mat-label>
      <input
        matInput
        formControlName="passwordNewConf"
        [type]="hideNewConf ? 'password' : 'text'"
      />
      <mat-error>
        <div *ngIf="keyChange.get('passwordNewConf').hasError('required')">
          {{ "Ingrese confirmación" }}
        </div>
        <div
          *ngIf="
            keyChange.value.passwordNewConf !== keyChange.value.passwordNew
          "
        >
          {{ "Las contraseñas no son iguales" }}
        </div>
      </mat-error>
      <button
        mat-icon-button
        matSuffix
        (click)="hideNewConf = !hideNewConf"
        [attr.aria-label]="'Hide password'"
        [attr.aria-pressed]="hideNewConf"
      >
        <mat-icon>{{ hideNewConf ? "visibility_off" : "visibility" }}</mat-icon>
      </button>
    </mat-form-field>
    <button
      style="width:100%"
      [disabled]="keyChange.invalid"
      mat-flat-button
      color="primary"
    >
      <mat-icon>person</mat-icon>
      Cambiar
    </button>
    <div class="message" fxLayout="column" fxLayoutGap="5px">
      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
        <mat-icon>check</mat-icon>
        <span
          >Esta opción le permite cambiar su clave de acceso al sistema.</span
        >
      </div>
      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
        <mat-icon>check</mat-icon>
        <span
          >Su nueva clave deberá combinar entre 8 y 15 caracteres alfanuméricos.
          Ej: Seg.123010#
        </span>
      </div>
      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
        <mat-icon>check</mat-icon>
        <span
          >Además su cuenta será bloqueada al fallar la conexión después de tres
          (3) intentos.</span
        >
      </div>
    </div>
  </form>
</section>
